module.exports = __webpack_public_path__ + "static/media/iconoBack.cc60c67c.svg";